let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aa9mr")).then(() => parcelRequire('6LCpG'));